"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiSelectDocument = void 0;
var types_1 = require("../../../types");
exports.multiSelectDocument = {
    dateCreated: "2021-07-26T19:09:11Z",
    form: {
        actions: [],
        allowedDocumentEditor: "DOCUMENT_CREATOR",
        defenses: [],
        displayConditions: [],
        id: 1195001,
        isRehuddleEligible: true,
        lastModifiedDate: "2021-07-16T17:09:45.848668Z",
        name: "Some Multi Selects",
        properties: null,
        relationshipTypes: [],
        rootId: 1195001,
        sections: [
            {
                id: 1195102,
                items: [
                    {
                        answerSource: null,
                        hasDefenses: false,
                        id: 1195404,
                        isGlobalQuestion: false,
                        properties: {},
                        rootId: 1195404,
                        selections: [
                            {
                                id: 1195553,
                                rootId: 1195553,
                                title: "Option 1",
                            },
                            {
                                id: 1195554,
                                rootId: 1195554,
                                title: "Option 2",
                            },
                        ],
                        subType: "MULTI_SELECT",
                        title: "Custom Options",
                        type: "QUESTION",
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: {
                            dataSourceKey: "123423",
                            id: 1195354,
                            isFromWidget: null,
                            properties: {
                                answerField: "value",
                                autoComplete: false,
                                dataSourceId: 570751,
                                detailedSearch: {
                                    infiniteListSortBy: "displayOrder,value",
                                },
                            },
                            type: "DATA_SOURCE",
                        },
                        id: 1195204,
                        rootId: 1195204,
                        selections: [],
                        subType: "MULTI_SELECT",
                        title: "Colors",
                        type: "QUESTION",
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: {
                            dataSourceKey: "WORK_LOCATION",
                            id: 1195355,
                            isFromWidget: null,
                            properties: {
                                answerField: "name",
                                autoComplete: false,
                                dataSourceId: 1300,
                                detailedSearch: {
                                    infiniteListSortBy: "name",
                                },
                            },
                            type: "DATA_SOURCE",
                        },
                        id: 1195405,
                        rootId: 1195405,
                        selections: [],
                        subType: "MULTI_SELECT",
                        title: "Work Location",
                        type: "QUESTION",
                        workflowType: "FINAL",
                    },
                ],
                parentWidgetRootId: null,
                properties: null,
                rootId: 1195102,
                title: "Some Multi Selects",
                workflowType: "FINAL",
            },
        ],
        sharingEnabled: true,
        signatureRequired: null,
        startFromWorkOrderEnabled: true,
        type: {
            active: true,
            id: 1,
            name: "Head Scratchers",
            isGlobal: true,
        },
        workflowType: "FINAL",
    },
    formActionRequests: [],
    formSummary: {
        id: 1195001,
        name: "Some Radio Buttons",
        rootId: 1195001,
        type: {
            active: true,
            id: 1,
            name: "Head Scratchers",
            isGlobal: true,
        },
        workflowType: "FINAL",
    },
    id: 1201151,
    operationalExperiences: [],
    owner: {
        fullName: 'Riley, Todd "The Toddster"',
        name: "Todd Riley",
        participantId: 1062251,
    },
    participants: [],
    photos: [],
    readOnly: false,
    responses: [],
    resubmissions: [],
    sectionComments: [],
    startDate: "2021-07-26T19:09:11Z",
    status: types_1.DocumentStatus.NEW,
    submissionDate: "2021-07-26T19:09:11Z",
    submissionId: 1201201,
    submissionType: types_1.DocumentSubmissionType.NEW,
    summary: {},
    title: "New Document",
};
//# sourceMappingURL=multiSelectDocument.js.map